import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Supplier_Reports } from "../../db_access/supplier_reports";
import ButtonAccept from "../Notification/ButtonAccept";
import ButtonReject from "../Notification/ButtonReject";

const InvitationReport = ({ report, setRefresh, showAction = true }) => {
  const { t } = useTranslation();
  const typographyCommon = { fontFamily: "Poppins", fontWeight: 100 };
  const typographyLeft = { ...typographyCommon, textAlign: "left" };
  const typographyRight = { ...typographyCommon, textAlign: "right" };
  const fields = [
    { label: t("Name"), field: "name" },
    { label: t("Level"), field: "level" },
    { label: t("Scope"), field: "scope" },
    { label: t("Year"), field: "year" },
    { label: t("Quantity"), field: "quantity" },
    { label: t("Functional Unit"), field: "functional_unit" },
    { label: t("Other Unit"), field: "other_unit" },
    { label: t("GWP per unit"), field: "gwp_per_unit" },
    { label: t("GWP"), field: "gwp" },
    { label: t("Cost per unit"), field: "cost_per_unit" },
    { label: t("Cost"), field: "cost" },
    { label: t("Notes"), field: "notes" },
  ];
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2, background: "#fcfcfc", width: "100%" }}>
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 2 }}>
        {fields
          .filter((f) => report?.[f.field] !== null && report?.[f.field] !== "")
          .map((f, i) => (
            <Box key={i} sx={{
              p: 1.5, borderRadius: "10px", background: "#ffffff", border: "1px solid #f1f5f9",
              ...(f.field === 'gwp' || f.field === 'cost' ? { borderColor: f.field === 'gwp' ? "#dbeafe" : "#dcfce7", background: f.field === 'gwp' ? "#f8fbff" : "#fafff8" } : {})
            }}>
              <Typography sx={{ fontFamily: "Poppins", fontSize: 10, color: "#9ca3af", fontWeight: 700, letterSpacing: 0.5, mb: 0.5 }}>{f.label.toUpperCase()}</Typography>
              <Typography sx={{
                fontFamily: "Poppins", fontSize: 13, fontWeight: 700,
                color: f.field === 'gwp' ? "#2563eb" : f.field === 'cost' ? "#16a34a" : "#334155"
              }}>
                {typeof report[f.field] === 'number' ? report[f.field].toLocaleString() : report[f.field]}
              </Typography>
            </Box>
          ))}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", pt: 1.5, borderTop: "1px dashed #e2e8f0", mt: 1 }}>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Box sx={{ display: showAction && report.status === "Pending" ? "block" : "none" }}>
            <ButtonAccept
              onClick={() => {
                Supplier_Reports.accept(report.id).finally(() => setRefresh((r) => !r));
              }}
            />
          </Box>
          <Box sx={{ display: showAction && report.status === "Pending" ? "block" : "none" }}>
            <ButtonReject
              onClick={() => {
                Supplier_Reports.reject(report.id).finally(() => setRefresh((r) => !r));
              }}
            />
          </Box>
          <Box
            sx={{
              display: report.status !== "Pending" ? "block" : "none",
            }}>
            <span className={`eng-badge eng-badge--${report.status.toLowerCase()}`}>{t(report.status)}</span>
          </Box>
        </Box>

        <Box sx={{ textAlign: "right" }}>
          <Typography sx={{ fontFamily: "Poppins", fontSize: 10, color: "#9ca3af" }}>
            {t("Created")}: <span style={{ color: "#64748b", fontWeight: 500 }}>{report.created_at.split(" GMT")[0]}</span>
          </Typography>
          <Typography sx={{ fontFamily: "Poppins", fontSize: 10, color: "#9ca3af" }}>
            {t("Updated")}: <span style={{ color: "#64748b", fontWeight: 500 }}>{report.last_modified.split(" GMT")[0]}</span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InvitationReport;
